/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function wr_backstretch() {
    // Check Backstretch is loaded
    if (!jQuery().backstretch) {
      return;
    }
    // Find all data-toggle="backstretch" elements
    var backstretches = $('[data-toggle=backstretch]');// Selector
    backstretches.each(function() {
      var backstretchEl = $(this);
      var backstretchTarget = backstretchEl.data('backstretch-target') || null;
      var backstretchImgs = [];
      var backstretchOpacity = backstretchEl.data('opacity') || null;
      var backstretchSettings = {
        fade: 750,
        duration: 4000
      };
    
      // Get images from element
      $.each(backstretchEl.data('backstretch-imgs').split(','), function(k, img) {
        backstretchImgs[k] = img;
      });
    
      if (backstretchImgs) {
        $('html').addClass('has-backstretch');
        
        // Opacity: add CSS to wrapper
        if (backstretchOpacity !== null) {
          $('html').addClass('backstretch-opacity-'+ backstretchOpacity);
        }
        
        // Merge in any custom settings
        backstretchSettings = $.extend({}, backstretchSettings, backstretchEl.data());
    
        // block level element
        if (backstretchTarget !== null) {
          if (backstretchTarget === 'self') {
            backstretchTarget = backstretchEl;
          }
          else {
            if ($(backstretchTarget).length > 0) {
              backstretchTarget = $(backstretchTarget);
            }
          }
          backstretchTarget.backstretch(backstretchImgs, backstretchSettings);
        }
        else {
          $.backstretch(backstretchImgs, backstretchSettings);
        }                 
      }
    });
  }


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('#fullpage').fullpage({
          anchors: ['homeSlider', 'homeContent'],
          paddingTop: '120px',
          paddingBottom: '0px',
          scrollOverflow: true,
          onLeave: function(index, nextIndex, direction){
            var leavingSection = $(this);

            //after leaving section 1
            if(index === 1 && direction === 'down'){
              //alert("Going to section 2!");
              $('header.banner > nav.navbar').addClass('navbar-light').removeClass('navbar-inverse');
              $('header.banner > nav.navbar .navbar-brand picture.logo-grau img').addClass('d-inline-block').removeClass('hidden');
              $('header.banner > nav.navbar .navbar-brand picture.logo-weiss img').addClass('hidden').removeClass('d-inline-block');
            }

            else if(index === 2 && direction === 'up'){
              //alert("Going to section 1!");
              $('header.banner > nav.navbar').addClass('navbar-inverse').removeClass('navbar-light');
              $('header.banner > nav.navbar .navbar-brand picture.logo-weiss img').addClass('d-inline-block').removeClass('hidden');
              $('header.banner > nav.navbar .navbar-brand picture.logo-grau img').addClass('hidden').removeClass('d-inline-block');
            }
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        wr_backstretch();
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'single_projekt': {
      init: function() {
        var $grid = $('#single-projekt-container').imagesLoaded( function() {
          $grid.masonry({
            itemSelector : '.bild',
            stamp: '.stamp', 
            layoutMode : 'masonry',
            percentPosition: true,
            isOriginLeft: true,
            masonry: {
              columnWidth: '.grid-sizer'
            }
          });
        });
      }
    },
    'single': {
      init: function() {
        var $grid = $('#single-projekt-container').imagesLoaded( function() {
          $grid.masonry({
            itemSelector : '.bild',
            stamp: '.stamp', 
            layoutMode : 'masonry',
            percentPosition: true,
            isOriginLeft: true,
            masonry: {
              columnWidth: '.grid-sizer'
            }
          });
        });
        fitty('.single-projekt #single-projekt-container article h1.card-title', {
          minSize: 24,
          maxSize: 40
         });
      }
    },
    'post_type_archive_projekt': {
      init: function() {
        var $grid = $('#projekte-container').imagesLoaded( function() {
          // init Isotope after all images have loaded
          $grid.isotope({
            itemSelector : '.projekt',
            stamp: '.stamp', 
            layoutMode : 'masonry',
            percentPosition: true,
            masonry: {
              columnWidth: '.grid-sizer'
            }
          });
        });

         // filter items on button click
          $('#projekte-filter').on( 'click', 'a', function() {
            if ( $(this).hasClass('active') ) {
             return false;
            }
            var $filterSet = $(this).parents('#projekte-filter');
            $filterSet.find('.active').removeClass('active');
            $(this).addClass('active');

            var filterValue = $(this).attr('data-filter');
            $grid.isotope({ filter: filterValue });
          });
         
         //Add the class selected to the item that is clicked, and remove from the others
         /*var $optionSets = $('#projekte-filter'),
         $optionLinks = $optionSets.find('a');
         
         $optionLinks.click(function(){
          var $this = $(this);
          // don't proceed if already selected
          if ( $this.hasClass('selected') ) {
           return false;
          }
          var $optionSet = $this.parents('#projekte-filter');
          $optionSets.find('.selected').removeClass('selected');
          $this.addClass('selected');
         
          //When an item is clicked, sort the items.
          var selector = $(this).attr('data-filter');
          $container.isotope({ filter: selector });
         
          return false;
         });*/
         fitty('.post-type-archive-projekt #projekte-container article h2.card-title', {
          minSize: 24,
          maxSize: 32
         });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
